import { ITableColumnMetadata } from '../../components/CustomTable/interfaces';

const tableColumnMetadata: Array<ITableColumnMetadata> = [
  {
    key: 'code',
    displayName: 'Ticket'
  },
  {
    key: 'customer.business.name',
    displayName: 'Empresa'
  },
  {
    key: 'customer.name',
    displayName: 'Cliente'
  },
  {
    key: 'customer.email',
    displayName: 'Correo electrónico'
  },
  {
    key: 'creationDate',
    displayName: 'Fecha de creación',
    type: 'date'
  },
  {
    key: 'manager.name',
    displayName: 'Responsable'
  },
  {
    key: 'time',
    displayName: 'Tiempo transcurrido',
    type: 'time'
  },
  {
    key: 'status',
    displayName: 'Estado',
    type: 'status',
    statusMap: {
      WAITING: {
        text: 'En espera',
        background: 'warning'
      },
      EXECUTING: {
        text: 'En ejecución',
        background: 'warning'
      },
      CLOSED: {
        text: 'Resuelto',
        background: 'success'
      }
    }
  },
  {
    key: 'actions',
    displayName: 'Acción',
    type: 'action',
    actions: ['ASIGNAR', 'CHAT']
  }
];

export default tableColumnMetadata;
